import { createEntityAdapter, createSlice, PayloadAction } from '@reduxjs/toolkit'

import customDeviceModel, { CreateCustomDeviceDto, CustomDevice, CustomDeviceState } from '@/core/models/custom-device.model'
import { RootState } from '@/redux/rootReducer'

export type CustomDeviceReducerState = CustomDeviceState

export const customDeviceAdapter = createEntityAdapter({ selectId: (customDevice: CustomDevice & { available?: boolean }) => customDevice._id })

const customDeviceSelector = customDeviceAdapter.getSelectors((state: RootState) => state.customDevice.customDevices)

export const selectCustomDevices = customDeviceSelector.selectAll

export const selectCustomDeviceCreateRequestState = (state: RootState) => state.customDevice.requestTracker.create
export const selectCustomDeviceDeleteRequestState = (state: RootState) => state.customDevice.requestTracker.delete

const initialState: CustomDeviceReducerState = {
  ...customDeviceModel.getInitialState()
}

const consultationSlice = createSlice({
  name: customDeviceModel.reducerName,
  initialState,
  reducers: {
    getCustomDevices(state) {
      state.requestTracker.list.loading = true
    },
    getCustomDevicesSuccess(state, action: PayloadAction<Array<CustomDevice & { available?: boolean }>>) {
      customDeviceAdapter.setAll(state.customDevices, action.payload)
      state.requestTracker.list.error = null
      state.requestTracker.list.loading = false
    },
    getCustomDevicesFailure(state, action) {
      state.requestTracker.list.loading = false
      state.requestTracker.list.error = action.payload
    },
    createCustomDevice(state, action: PayloadAction<CreateCustomDeviceDto>) {
      state.requestTracker.create.loading = true
    },
    createCustomDeviceSuccess(state, action: PayloadAction<CustomDevice & { available?: boolean }>) {
      customDeviceAdapter.addOne(state.customDevices, action.payload)
      state.requestTracker.create.error = null
      state.requestTracker.create.loading = false
    },
    createCustomDeviceFailure(state, action) {
      state.requestTracker.create.loading = false
      state.requestTracker.create.error = action.payload
    },
    deleteCustomDevice(state, action: PayloadAction<string>) {
      state.requestTracker.delete.loading = true
    },
    deleteCustomDeviceSuccess(state, action: PayloadAction<string>) {
      customDeviceAdapter.removeOne(state.customDevices, action.payload)
      state.requestTracker.delete.error = null
      state.requestTracker.delete.loading = false
    },
    deleteCustomDeviceFailure(state, action) {
      state.requestTracker.delete.loading = false
      state.requestTracker.delete.error = action.payload
    }
  }
})

export const {
  getCustomDevices,
  getCustomDevicesSuccess,
  getCustomDevicesFailure,
  createCustomDevice,
  createCustomDeviceSuccess,
  createCustomDeviceFailure,
  deleteCustomDevice,
  deleteCustomDeviceSuccess,
  deleteCustomDeviceFailure
} = consultationSlice.actions

export default consultationSlice.reducer